import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgTBoats = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 21"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M200 10.48v10.203h-11.458l1.674-10.202zM78.835 0c3.074 0 4.054 1.677 4.054 1.677v12.996h48.495c33.12 0 52.965 6.01 52.965 6.01H0c9.07-3.35 30.45-5.486 43.059-5.925v-2.46a1.118 1.118 0 1 1 2.236 0v2.398c.741-.015 1.445-.023 2.097-.023h12.437V1.956C59.829.559 63.043 0 63.043 0z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgTBoats
